import React from "react";
import clickToExpandFeed from "images/clickToExpandFeed.png";

const HlpSideVideos = () => {
  return (
    <>
      <h1>Click on someone's video to enlarge</h1>
      <div className="centred-helper">
        <img
          style={{ margin: 0, marginBottom: "-10px" }}
          src={clickToExpandFeed}
          alt="click to expand video feed"
        />
      </div>
    </>
  );
};

export default HlpSideVideos;
